import axios from 'axios'

// axios 配置
axios.defaults.timeout = 60000;

axios.defaults.baseURL = process.env.SERVER_ADDRESS;
axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';

// http request 拦截器
axios.interceptors.request.use(config => {
  if (process.env.SERVER_ADDRESS.startsWith('http://127.0.0.1')) {
    config['data'] = { ...config['data'], userId: 25 };
  } else {
    if (config['data']) {
      if (config['url'] === 'api/user/getAllLearnTask'
        || config['url'] === 'api/user/getPageUserInfo'
        || config['url'] === 'api/user/changeLearnTask'
        || config['url'] === 'api/learnTask/getLearnTaskView'
        || config['url'] === 'api/learnTask/deleteLearnTask'
        || config['url'] === 'api/statistics/statisticsUserLearnTask'
        || config['url'] === 'api/statistics/statisticsUserLearnTaskFromTeacher'
        || config['url'] === 'api/statistics/statisticsUserLearnTaskFromUser'
        || config['url'] === 'api/notice/get'
        || config['url'] === 'api/notice/insertOrUpdate'
        || config['url'] === 'api/notice/uploadImg'
        || config['url'] === 'api/login/restLastUserRecord') {

      } else {
        // let userId = 25;
        // const userId = this.$cookies.get("uid");
        // alert();

        let userId = sessionStorage.getItem("_uid");
        if (userId) {
          config['data'] = { ...config['data'], userId: userId};
        } else {
          alert('请关闭当前页面后，重新操作');
          // config['data'] = { ...config['data'], userId: 25};
          //location.href = 'https://xiandaoxueyuan.com/?m=user2&a=login';
        }
      }
    }
  }
  return config
}, err => {
  return Promise.reject(err)
});

// http response 拦截器
axios.interceptors.response.use(response => {

  return response.data
}, error => {

  return Promise.reject(error.response)
});

export default axios



// WEBPACK FOOTER //
// ./src/utils/http.js